import React from "react";
import { IoDocumentText } from "react-icons/io5";
import { AiOutlineSchedule } from "react-icons/ai";
import AccesoDirecto from "../../molecules/dashboard/AccesoDirecto";
import { BsArchiveFill } from "react-icons/bs";
import { FaFileInvoiceDollar, FaCalendarAlt, FaTools } from "react-icons/fa";
import { TbCalendarDollar } from "react-icons/tb";
import { LuNotebookTabs } from "react-icons/lu";
import { MdMarkunreadMailbox } from "react-icons/md";

const AccesosDirectosDocuments = ({ empresa }) => {
    const documentos = [
        { name: "ARCHIVO PERMANENTE", path: `/clientes/empresas/${empresa.id}/archivo_permanente`, icon: BsArchiveFill},
        { name: "OPINIONES DE CUMPLIMIENTO", path: `/clientes/empresas/${empresa.id}/opiniones_cumplimiento`, icon: IoDocumentText},
        { name: "DECLARACIÓN ANUAL", path: `/clientes/empresas/${empresa.id}/declaracion_anual`, icon: FaCalendarAlt},
        { name: "PAGOS PROVISIONALES", path: `/clientes/empresas/${empresa.id}/pagos_provicionales`, icon: FaFileInvoiceDollar},
        { name: "REPORTES FINANCIEROS", path: `/clientes/empresas/${empresa.id}/reportes_financieros`, icon: AiOutlineSchedule},
        { name: "BUZONES", path: `/clientes/empresas/${empresa.id}/buzones`, icon: MdMarkunreadMailbox},
        { name: "ESTADO DE CUENTA SERVICIOS RS", path: `/clientes/empresas/${empresa.id}/estado_cuenta`, icon: TbCalendarDollar},
        { name: "REUNIONES", path: `/clientes/empresas/${empresa.id}/reuniones`, icon: LuNotebookTabs},
        { name: "HERRAMIENTAS", path: `/clientes/empresas/${empresa.id}/herramientas`, icon: FaTools},
    ];

    return(
        <div className="grid grid-cols-1 lg:grid-cols-3 pt-4 gap-4">
            {documentos?.map((document, index) => (
                <AccesoDirecto label={document?.name} href={document?.path} icon={document?.icon} key={index} />
            ))}
        </div>
    );
};

export default AccesosDirectosDocuments;